import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Input, NgZone, OnDestroy, OnInit, QueryList, SimpleChanges, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { ApiService } from 'src/services/apiservice.service';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { checklistItem, createResponse } from 'src/models/checklist';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { DeviceDetectorService } from 'ngx-device-detector';
// import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { customizing } from '../../models/customizing';
import { DashboardComponent } from 'src/usermodule/dashboard/dashboard.component';
import { MatOption } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/services/dataservice.service';
import { CameraCaptureComponent } from './camera-capture/camera-capture.component';
import { User } from 'src/models/userlist';
import { debounceTime, Subject, Subscription, takeUntil, tap } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { ConfigService } from 'src/services/config.service';
import * as pdfjsLib from 'pdfjs-dist';
import { title } from 'process';

declare var $: any;

interface PdfViewerState {
  scrollTop: number;
  scrollLeft: number;
  scale: number;
  page: number;
  updatedAt?: number;
}
@Component({
  selector: 'app-checklist-modal',
  templateUrl: './checklist-modal.component.html',
  styleUrls: ['./checklist-modal.component.scss'],
  providers: [NgbModal],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChecklistModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('content') private content: TemplateRef<Object>;
  @ViewChild('instructions') public instructionspopup: TemplateRef<Object>;
  @ViewChild('checklist') public checklistpopup: TemplateRef<Object>;
  @ViewChild('suncircle') public suncircle: TemplateRef<Object>;
  @ViewChild('compactchecklist') public compactchecklist: TemplateRef<Object>;
  @ViewChild('checklisttop') public checklisttop: TemplateRef<Object>;
  @ViewChild('onlyChecklist') public onlyChecklist: TemplateRef<Object>;
  @ViewChild('checklistinstructions') public checklistinstructions: TemplateRef<Object>;
  @ViewChild('extrainputmodal') public extrainputpopup: TemplateRef<Object>;
  @ViewChild('instructionanddocuments') public instructionanddocuments: TemplateRef<Object>;
  @ViewChild('topinstructionchecklist') public topinstructionchecklist: TemplateRef<Object>;
  @ViewChild('confirmation') public confirmation: TemplateRef<Object>;
  @ViewChildren('video') videoRefs!: QueryList<ElementRef<HTMLVideoElement>>;
  @ViewChildren('canvas') canvasRefs!: QueryList<ElementRef<HTMLCanvasElement>>;
  pdfViewerUrl!: SafeResourceUrl | null;
  videoRef!: ElementRef<HTMLVideoElement>;
  canvasRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('cameraModal') cameraModal: TemplateRef<any>;
  @ViewChildren('pdfViewerFrame')
  private pdfViewerFrames!: QueryList<ElementRef<HTMLIFrameElement>>;

  pdfViewers: Array<{
    attachmentIndex: number;
    documentType: string;
    fileUrl: string;
    sourceKey: string;
    viewerUrl: SafeResourceUrl;
  }> = [];

  pdfViewerStates: Record<number, PdfViewerState> = {};
  activePdfAttachmentIndex: number | null = null;

  private pdfObjectUrls: string[] = [];
  private remotePdfUrls = new Map<string, Promise<string>>();
  private documentSelectionId = 0;
  @Input() checkListFormGroup: any;
  @Input() checkListFormGroup1: any;
  @Input() checkListItems: any;
  @Input() checkListItems1: any;
  @Input() layout: any;
  @Input() conurrentUsers: string[] = [];
  @Input() autosave: any;
  @Input() approverInfo: any;
  //@Input() public goodsReciptFlag: any;
  selectedOption: string;
  instructionsItems: any;
  payload: { processStep: string; orderID: string; userID: string; };
  @Input() orderID: string;
  @Input() attachments: any;
  Werkbon = false;
  customizing: any;
  deviceInfo: import('ngx-device-detector').DeviceInfo;
  @Input() public goodsRecipt: any;
  @Input() public requiresValidationOnSubmit: boolean;
  isD = true;
  src: any;

  productForm: any;
  currentuser: any;
  modalref: NgbModalRef;
  showChecklist: any;
  stepFlag: string;
  extraInputForm: any;
  showInstructions: boolean;
  isLoading: boolean = true;
  public parentResult: any = [];
  // deviceInfo: import('ngx-device-detector').DeviceInfo;
  isKeyboard: boolean = false;
  allSelected = false;
  checklistModalRef: NgbModalRef;
  imageUrl: SafeResourceUrl | null = null;
  currentDocumentType: 'pdf' | 'image' | null = null;

  takenPhotos: SafeUrl[] = [];
  cameraOn: boolean = false;
  errorMessage: string | null = null;
  public stream: MediaStream | null = null;
  selectedFormat: string = 'jpeg'; // Default image format
  currentFacingMode: string = 'user'; // Default to front camera ('user' or 'environment')
  availableCameras: MediaDeviceInfo[] = []; // Store available video devices
  showCameraModal = false;
  
  usersList: User[] = [];
  selectedUserControl = new FormControl<string | null>(null);
  blobPdf: boolean = false;
  currentlang: any;
  errorMsg = false;
  isShow = true;
  isShoww = true;
  secondOrderId = '';
  workstationid: any;
  customerID: any;
  @Input() checklistFormList: any;
  @Input() check_List: any;
  isshowDependingOn = true;
  pdfFlag: boolean;
  orderIDD: any;
  showInput = false;
  diactivatedFlag = false;
  diactivatedFlagfromdash = false;
  public checkfields: any;
  public getPostValues: any;
  public defaultValue: any;
  public layoutValues = [];
  public forceVirtualKeyboardEnabled = true;
  updatedFormData: { [key: string]: any } = {};
  nextPage: any;
  index = 1;
  maxIndex = 0;
  checklistItemss: any = []
  payloadForConfirmation: any;
  confirmationMessage: any;
  modalRef: NgbModalRef | null = null;
  formattedConfirmationMessage: any;
  @Input() instructionsDocumentValue: any;
  instructionsSidebar: any;
  private socket: Socket;
  displayConcurrencyMessage: boolean = true;
  config: any;
  public showChecklistOption: boolean = true;
  autosaveTimeout: any;
  isDebouncing: boolean = false;
  alreadySaved: boolean;
  nfcStatus: 'idle' | 'listening' | 'success' | 'timeout' = 'idle';
  private nfcTimeout: any;
  private nfcBuffer = '';
  private keyboardListener!: (event: KeyboardEvent) => void;
  constructor(
    private cd: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private sanitizer: DomSanitizer,
    private DashboardComponent: DashboardComponent,
    public fb: UntypedFormBuilder,
    private apiservice: ApiService,
    private DataService: DataService,
    private toastrService: ToastrService,
    private configService: ConfigService,
    private modalService: NgbModal,
    private ngZone: NgZone) {
    this.workstationid = localStorage.getItem('workstationID');
    this.currentuser = localStorage.getItem('current_user');
    this.customerID = localStorage.getItem('customerID');
    (this.currentuser) ? this.currentuser = JSON.parse(this.currentuser) : '';
    if(this.approverInfo?.value) {
      this.selectedUserControl.setValue(this.approverInfo?.value || null);
      this.nfcStatus = 'success';
    }
    this.productForm = this.fb.group({
      quantity: [1, [Validators.required]],
      types: [],
      default_quantity: [1,]
    });
    this.extraInputForm = this.fb.group({
      quantity: [1, [Validators.required]],
    });
    this.currentlang = localStorage.getItem('language');
    this.configService.getConfigAsync()
    .pipe(
      tap((config: any) => {
        this.config = config;
      })
    )
    .subscribe();
    // this.socket = io(this.config.socketUrl);
    // this.socket.on('connect', ()=>{
    //   console.log('Connected to socket in checklist..')
    // });
    // this.socket.onAny((event,message)=>{
    //   this.checkConcurrentWarningVisibility(message)
    // })
  }
  checklistFormGroup: FormGroup<any>;
  locatieForm = new FormGroup({});
  inputText: string = '';
  
  isSaveButtonDisabled = true;
  saveMessage: boolean | null = null;
  formChangeSubscription: Subscription | null = null; 
  stopClose = false;
  speedSaveDisabled: boolean = false;
  private destroy$ = new Subject<void>();

  restorePdfScroll(viewer: { attachmentIndex: number }): void {
  const frame = this.pdfViewerFrames?.find(
    item =>
      Number(item.nativeElement.dataset['pdfIndex']) ===
      viewer.attachmentIndex
  );

  frame?.nativeElement.contentWindow?.postMessage(
    {
      type: 'restore-pdf-scroll',
      attachmentIndex: viewer.attachmentIndex,
      state: this.pdfViewerStates[viewer.attachmentIndex] || null
    },
    window.location.origin
  );
}

onPdfViewerLoad(viewer: { attachmentIndex: number }): void {
  this.restorePdfScroll(viewer);
  this.loadingPDF();
}

@HostListener('window:message', ['$event'])
onPdfScrollMessage(event: MessageEvent): void {
  if (event.origin !== window.location.origin) return;

  const message = event.data;

  if (message?.type !== 'pdf-viewer-scroll') return;

  const attachmentIndex = Number(message.attachmentIndex);

  const frame = this.pdfViewerFrames?.find(
    item =>
      Number(item.nativeElement.dataset['pdfIndex']) ===
      attachmentIndex
  );

  // Accept state only from the matching iframe.
  if (event.source !== frame?.nativeElement.contentWindow) return;

  const state = message.state;

  if (
    !Number.isInteger(attachmentIndex) ||
    !state ||
    !Number.isFinite(state.scrollTop) ||
    !Number.isFinite(state.scrollLeft) ||
    !Number.isFinite(state.scale) ||
    !Number.isFinite(state.page) ||
    state.scrollTop < 0 ||
    state.scrollLeft < 0 ||
    state.scale <= 0 ||
    state.page < 1
  ) {
    return;
  }

  this.pdfViewerStates[attachmentIndex] = {
    scrollTop: state.scrollTop,
    scrollLeft: state.scrollLeft,
    scale: state.scale,
    page: state.page,
    updatedAt: Number.isFinite(state.updatedAt) ? state.updatedAt : undefined
  };
}


  @HostListener('document:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    if (!this.diactivatedFlag && this.diactivatedFlagfromdash) {
      if (/^[a-zA-Z0-9]$/.test(event.key)) {
        this.inputText += event.key.toLowerCase();
        if (this.inputText.startsWith('http') || this.inputText.startsWith('https')) {
          this.showInput = true;
          $(document).ready(function (ex: any) {
            $('#inputvalue').focus();
          })
          event.stopPropagation();
          event.preventDefault();
        }
        else {
          this.showInput = false;
          // this.inputText = '';
        }
      }
      else if (event.key === 'Enter') {
        const urlPattern = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;
        if (urlPattern.test(this.inputText)) {
          window.open(this.inputText, '_blank');
          this.inputText = '';
          this.showInput = false;
        }
        else {
          this.inputText = '';
          this.showInput = false;
        }
      }
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['instructionsDocumentValue']) {
      const currentValue = changes['instructionsDocumentValue'].currentValue;
      if (currentValue) {
        this.instructionsSidebar = true;
      }
    }
    if (changes['checkListItems1']) {
      this.checkListItems = changes['checkListItems1'].currentValue;
      if(this.checkListItems?.length >0) {
        this.previewData();
        this.instructionsSidebar = true;
      }
    }
    if (changes['attachments']) {
      const attachmentsValue = changes['attachments'].currentValue;
      // An empty list is authoritative too; do not retain another order's files.
      this.attachments = Array.isArray(attachmentsValue) ? attachmentsValue : [];
      if (!this.attachments.length) {
        this.imageUrl = null;
        this.currentDocumentType = null;
        this.blobPdf = false;
        this.pdfViewerUrl = null;
        this.src = null;
        this.Werkbon = false;
        this.isD = true;
        if (this.checklistModalRef && this.selectedOption !== 'checklist') {
          this.showChecklist = true;
          this.setOption('checklist', '');
        }
      }
      this.cd.detectChanges();
      if(attachmentsValue?.length > 0 || attachmentsValue?.result) {
        this.instructionsSidebar = true;
      }
      // Order-response can open the modal before attachments arrive; focus Foto once they load.
      if (this.checklistModalRef && (this.selectedOption === 'instructions' || this.selectedOption === 'checklist' || !this.selectedOption)) {
        this.focusFotoTabIfNeeded(attachmentsValue);
      }
    }
    if (changes['autosave']) {
      this.isSaveButtonDisabled = changes['autosave'].currentValue !== 1;
      this.isSaveButtonDisabled = !!this.autosave;
    }
    if (changes['checkListFormGroup1']) {
      this.checkListFormGroup = changes['checkListFormGroup1'].currentValue;
    }
    if (changes['approverInfo']) {
      if(changes['approverInfo'].currentValue.value){
          this.nfcStatus = 'success';
          this.selectedUserControl.setValue(changes['approverInfo'].currentValue.value || null);
      }
    }
    if (this.checkListItems?.length == 0 || this.checkListItems == undefined) {
      this.checkListItems = this.checkListItems1
    }
    else if (!this.checkListFormGroup?.value?.details) {
      this.checkListFormGroup = this.checkListFormGroup1;
    }
  }
  ngOnInit(): void {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    if (this.deviceInfo.deviceType === 'mobile') {
      this.isKeyboard = true
    }                  
    if(this.approverInfo?.value) {
      this.nfcStatus = 'success'; 
      this.selectedUserControl.setValue(this.approverInfo?.value || null);
      this.selectedUserControl.updateValueAndValidity();
    }
    this.apiservice.listenToAnyEvent().pipe(
      takeUntil(this.destroy$)
    ).subscribe(({ message }) => {
      this.checkConcurrentWarningVisibility(message);
      this.cd.detectChanges(); // Trigger change detection if needed
    });
  }

  //getting called after each form change
  triggerChecklistChange(debounced: boolean= false) {
    if (this.autosave === 1) {
      console.log('triggering autosave')
      this.isSaveButtonDisabled = false;
      this.autosaveTimeout = setTimeout(()=>{
        this.addChecklist('', null, false, true);
      }, debounced ? 0 : 3000);
      
    }
  }

  ngDoCheck() {
    if (this.checkListItems?.length == 0 || this.checkListItems == undefined) {
      
      this.checkListItems = this.checkListItems1
    }
    else if (!this.checkListFormGroup?.value?.details) {
      this.checkListFormGroup = this.checkListFormGroup1;
    }
    if (this.attachments?.length > 0 || this.attachments) {
      this.isShow = false;
    }

    if(this.checkListFormGroup instanceof FormGroup && !this.formChangeSubscription && this.modalService.hasOpenModals()){
      this.formChangeSubscription = this.checkListFormGroup.valueChanges.pipe(
        tap((input)=>{
          this.isSaveButtonDisabled = false;
          console.log('form change found....')
          this.isDebouncing = true;
          this.alreadySaved = false;
        }),
        debounceTime(3000))
        .subscribe(()=>{
          if(!this.alreadySaved){
            this.triggerChecklistChange(true);
          }
      }
      )
    }
  }

  async ngAfterViewInit() {
    // Enumerate devices to check available cameras
    await this.getAvailableCameras();
  }

  hideForUrl() {
    this.inputText = '';
    this.showInput = false;
  }
  toSelectUrl(value: any) {
    this.diactivatedFlag = true;
    this.showInput = false;
  }
  loadingPDF() {
    this.isLoading = false;
    this.cd.detectChanges();
  }

  onImageLoad(): void {
    this.isLoading = false;
    this.cd.detectChanges();
  }

  onImageError(): void {
    this.isLoading = false;
    this.cd.detectChanges();
  }

  private isImageSource(data: any, fileUrl: string): boolean {
    if (data?.document_type == 'Foto') {
      return true;
    }
    return /\.(jpe?g|png|gif|bmp|webp|svg)(\?.*)?$/i.test(fileUrl);
  }

  valueChange(item: any, prop: any) {
    this.checkListFormGroup.patchValue({
      [prop.fieldName]: item
    });
    this.checkListItems.find((element: any) => {
      if (element.fieldName == prop.fieldName) {
        element.value = item;
      }
    });
  }

  resetForm() {
    // this.modalService.dismissAll();
    // this.checkListFormGroup.reset({});
  }
  addCompact(submitButton: HTMLButtonElement) {
    submitButton.disabled = true;
    let obj = []
    for (let item of this.checkListItems) {
      if (item?.body) {
        for (let prop of item?.body) {
          for (let list of prop) {
            const fieldName = list?.fieldName;
            if (this.checkListFormGroup.value[list?.fieldName] != undefined) {
              let temp = this.checkListFormGroup.value[list?.fieldName];
              this.updatedFormData[fieldName] = temp;
              const cloned = { ...list, value: temp };
              obj.push(cloned);
            }
          }
        }
      }
      if (item?.header) {
        for (let list of item?.header) {
          const fieldName = list?.fieldName;
          if (this.checkListFormGroup.value[list?.fieldName] != undefined) {
            let temp = this.checkListFormGroup.value[list?.fieldName];
            this.updatedFormData[fieldName] = temp;
            const cloned = { ...list, value: temp };
            obj.push(cloned);
          }
        }
      }
    }
    let item = this.checkListFormGroup.value.details;
    let approverPayload = null;
    if(this.approverInfo){
      approverPayload = this.approverInfo;
      approverPayload.value = this.selectedUserControl.value;
    }
    let payload = {
      ...item,
      ...(approverPayload ? {"approver": approverPayload} : {}) ,
      "values": obj
    };
    this.apiservice.createCheckList(payload).subscribe(
      (res: createResponse) => {

        submitButton.disabled = false
        if (res.askForConfirmation === true) {
          this.confirmationMessage = res.confirmationContent;
          this.formattedConfirmationMessage = this.confirmationMessage.replace(/- /g, '<br>');
          payload.confirmation = true;
          this.payloadForConfirmation = payload;
          this.modalRef = this.modalService.open(this.confirmation, { size: "md", backdrop: 'static', keyboard: false })
        }
        else if (this.requiresValidationOnSubmit) {
          if (res.response === 'success') {
            // this.modalService.dismissAll();
            this.closeModal();
            this.DashboardComponent.openCloseInstructionModal('2', '', '', '', this.pdfFlag, false, false);
            this.orderIDD = item.orderID
            setTimeout(() => {
              this.postPrintDetails('1', false);
            }, 200);
          }
          else {
          }
        }
        if (res.response === 'validationFailed') {
          this.toastrService.error(res.errorMessage, 'Error!');
        }
        else {
          this.closeModal();
          // this.modalService.dismissAll();
          this.DashboardComponent.openCloseInstructionModal('2', '', '', '', this.pdfFlag, false, false);
          this.orderIDD = item.orderID
          setTimeout(() => {
            this.postPrintDetails('1', false);
          }, 200);
        }

      },
      (error: any) => {
        console.log(error)
      }
    );
  }
  async addChecklist(pitem: any, submitButton: HTMLButtonElement | null, close: boolean, autosaved: boolean | null= null) : Promise<boolean> {
    return new Promise((resolve, reject) => {
    if(submitButton as HTMLButtonElement) (submitButton !).disabled = true;
    var option: any = {}
    let checkingTextfield = false;
    let checkfield;
    let isInvalid: boolean[] = [];
    this.checkListItems.forEach((item:any)=>{
      this.validateInput(item);
      isInvalid.push(this.hasAnyError(item));
    })
    if(isInvalid.some((v:boolean)=> v) && this.autosave !== 1) {
      this.stopClose = true;
      if(submitButton as HTMLButtonElement) (submitButton !).disabled = false;
      resolve(false);
      return;
    }
    if(isInvalid.filter((item:boolean)=> item).length > 0) {
      if(!this.isSaveButtonDisabled) {this.isSaveButtonDisabled = true;}
      resolve(false);
      return;
    }
    if (!autosaved && this.autosave == 1) {
      if(this.autosaveTimeout){
      clearTimeout(this.autosaveTimeout);
      this.autosaveTimeout = null;
      }
      if(this.isDebouncing){
        this.isDebouncing = false;
        this.alreadySaved = true;
      }
    }
    for (let i = 0; i < this.checkListItems?.length; i++) {
      const fieldKey = this.checkListItems[i]?.fieldID ?? this.checkListItems[i]?.fieldName;
      if (this.checkListFormGroup.value[fieldKey] != undefined) {
        let splittedDate;
        if (this.checkListItems[i].fieldType == 'date') {
          let date = this.checkListFormGroup.value[fieldKey];
          let year = new Date(date).getFullYear();
          let month = new Date(date).getMonth() + 1;
          let day = new Date(date).getDate();
          splittedDate = day + '-' + month + '-' + year;
          this.checkListItems[i].value = splittedDate;
        }
        else if (this.checkListItems[i].fieldType == 'checkbox') {
          let temp = (this.checkListFormGroup.value[fieldKey] == true || this.checkListFormGroup.value[fieldKey] == '1' || this.checkListFormGroup.value[fieldKey] == true) ? true : false;
          this.checkListItems[i].value = temp;
        }
        else if (this.checkListItems[i].fieldType === 'select') {

          let temp = this.checkListFormGroup.value[fieldKey];
          this.checkListItems[i].value = temp;
          // let tempp=this.checkListItems[i]['multi-select']?temp:[temp]
          //  let kl:any=[]
          // this.checkListItems[i].options.forEach((v:any,l:any)=>{
          //   tempp.forEach((key:any)=>{
          //     if(v.id === key){
          //       kl.push(v)
          //     }
          //     else{
          //     }
          //   })
          //  })
          //  option[i]={
          //   options:kl
          //  }
        }
        else if (this.checkListItems[i].fieldType === 'text' && this.checkListItems[i].allowedValues && this.checkListItems[i].allowedValues.length > 0) {

          if (this.checkListItems[i].allowedValues) {
            checkingTextfield = true
            let temp = this.checkListFormGroup.value[fieldKey];
            checkfield = this.checkListItems[i].allowedValues.filter((v: any) => v === temp)
            this.checkListItems[i].value = temp;
          }
        }
        else {
          this.checkListItems[i].value = this.checkListFormGroup.value[fieldKey]
        }
      }
      let activeorder = JSON.parse(localStorage.getItem("active_order") || '{}');
      if (this.checkListFormGroup.value.details) {
        // this.checkListFormGroup.value.details.orderID = this.secondOrderId != '' ? this.DashboardComponent.secondOrderId : activeorder.orderID != '' ? activeorder.orderID : this.checkListFormGroup.value.details.orderID;
      }
    }
    this.checkfields = checkfield
    // if (this.isshowDependingOn) {
    if (checkingTextfield) {
      if (checkfield.length > 0) {
        console.log('AUTOSAVE>>>>', this.autosave)
        let item = this.checkListFormGroup.value.details;
        let approverPayload = null;
        if(this.approverInfo){
          approverPayload = this.approverInfo;
          approverPayload.value = this.selectedUserControl.value;
        }
        let payload = {
          ...item,
          ...(approverPayload ? {"approver": approverPayload} : {}) ,
          "values": this.checkListItems,
          ...(autosaved ? {"autosave": true} : (autosaved === false ? {"autosave": false} : {}))
        };

        this.checkListFormGroup.reset({});
        if(!submitButton) this.isSaveButtonDisabled = true;
        this.apiservice.createCheckList(payload).subscribe(
          (res: createResponse) => {
            if (res.askForConfirmation === true) {
              this.confirmationMessage = res.confirmationContent;
              this.formattedConfirmationMessage = this.confirmationMessage.replace(/- /g, '<br>');
              payload.confirmation = true;
              if(submitButton as HTMLButtonElement) (submitButton !).disabled = false;
              this.payloadForConfirmation = payload;
              this.modalRef = this.modalService.open(this.confirmation, { size: "md", backdrop: 'static', keyboard: false })
            }
            if (res.response === "success" && !submitButton ) {
              this.isSaveButtonDisabled = true;
              if(autosaved) this.showSaveMessage(true);
              if(this.autosaveTimeout){
                clearTimeout(this.autosaveTimeout);
                this.autosaveTimeout = null;
              }
              if(close){
                this.closeModal();
              }
              resolve(true);
            }else {
              this.isSaveButtonDisabled = false;
              if(autosaved) this.showSaveMessage(false);
              resolve(false);
            }
            if (res.response === 'validationFailed') {
              this.isSaveButtonDisabled = true;
              this.stopClose = true;
              this.toastrService.error(res.errorMessage, 'Error!');
              if(this.autosaveTimeout){
                clearTimeout(this.autosaveTimeout);
                this.autosaveTimeout = null;
              }
              if(!this.requiresValidationOnSubmit && close){
                this.stopClose = false;
                this.closeModal()
              }
            }
            
            if(submitButton as HTMLButtonElement) (submitButton !).disabled = false;
            this.DashboardComponent.modaldismiss = true;
            this.DashboardComponent.openCloseInstructionModal('2', '', '', '', this.pdfFlag, false, false);
            this.orderIDD = item.orderID
            setTimeout(() => {
              this.postPrintDetails('1', false);
            }, 200);
          },
          (error: any) => {
            console.log(error);
            if(submitButton as HTMLButtonElement) (submitButton !).disabled = false;
            resolve(false);
          }
        );

      }
      else {

        let currentlang = JSON.parse(localStorage.getItem('cuurenLanguage') || '{}');
        (Object.keys(currentlang).length) ? this.currentlang = currentlang.name : this.currentlang = 'English'
        let errormsg;
        this.errorMsg = true;
        if(submitButton as HTMLButtonElement) (submitButton !).disabled = false;
        if (this.currentlang === 'Dutch') {
          errormsg = 'Opgegeven waarde niet toegestaan'
        }
        else if (this.currentlang === 'English') {
          errormsg = 'Value provided is not allowed'
        }
        else {
        }
        this.toastrService.error(errormsg, 'Error!');
      }
    } else {


      let item = this.checkListFormGroup.value.details;
      let approverPayload = null;
      if(this.approverInfo){
        approverPayload = this.approverInfo;
        approverPayload.value = this.selectedUserControl.value;
      }
      let payload = {
        ...item,
        ...(approverPayload ? {"approver": approverPayload} : {}) ,
        "values": this.checkListItems,
          ...(autosaved ? {"autosave": true} : (autosaved === false ? {"autosave": false} : {}))
      };
      // this.checkListFormGroup.reset({});
      if (pitem == 'small') {
        if(close) {
          // this.modalService.dismissAll();
          this.closeModal();
        }
      }
      this.apiservice.createCheckList(payload).subscribe(
        (res: createResponse) => {
          if (res.askForConfirmation === true) {
            this.confirmationMessage = res.confirmationContent;
            this.formattedConfirmationMessage = this.confirmationMessage.replace(/- /g, '<br>');
            payload.confirmation = true;
            this.payloadForConfirmation = payload;
            this.modalRef = this.modalService.open(this.confirmation, { size: "md" })
          }
          if (res.response === 'validationFailed') {
            this.isSaveButtonDisabled = true;
            this.stopClose = true;
            this.toastrService.error(res.errorMessage, 'Error!');
            if(this.autosaveTimeout){
              clearTimeout(this.autosaveTimeout);
              this.autosaveTimeout = null;
            }
            if(!this.requiresValidationOnSubmit && close){
              this.stopClose = false;
              this.closeModal()
            }
            resolve(false);
          }
          if(submitButton as HTMLButtonElement) (submitButton !).disabled = false;
          if (res.response === "success") {
            if(close) {
              this.closeModal();
            }
            if(!submitButton){
              this.isSaveButtonDisabled= true;
              if(autosaved) this.showSaveMessage(true);
            }
            if(this.autosaveTimeout){
                clearTimeout(this.autosaveTimeout);
                this.autosaveTimeout = null;
              }
            resolve(true);
          }else if(!submitButton){
            this.isSaveButtonDisabled= false;
              if(autosaved) this.showSaveMessage(false);
          }
          if (res.askForConfirmation === true) {
            this.confirmationMessage = res.confirmationContent;
            this.formattedConfirmationMessage = this.confirmationMessage.replace(/- /g, '<br>');
            payload.confirmation = true;
            if(submitButton as HTMLButtonElement) (submitButton !).disabled = false;
            this.payloadForConfirmation = payload;
            this.modalRef = this.modalService.open(this.confirmation, { size: "md", backdrop: 'static', keyboard: false })
          }
          this.orderIDD = item?.orderID
          this.DashboardComponent.modaldismiss = true;
          this.DashboardComponent.openCloseInstructionModal('2', '', '', '', this.pdfFlag, false, false);
          setTimeout(() => {
            this.postPrintDetails('1', false);
          }, 200);

        },
        (error: any) => {
          if(submitButton as HTMLButtonElement) (submitButton !).disabled = true;
          console.log(error)
          resolve(false);
        }
      );

    }
    // }
    // else {
    //   submitButton.disabled = false
    // }
})
  }
  aaddChecklist(pitem: any, submitButton: HTMLButtonElement, close: boolean, autosaved: boolean | null = null) {
    submitButton.disabled = true;
    var option: any = {}
    let checkingTextfield = false;
    let checkfield;
    for (let i = 0; i < this.check_List?.length; i++) {
      const fieldKey = this.check_List[i]?.fieldID ?? this.check_List[i]?.fieldName;
      if (this.checklistFormList.value[fieldKey] != undefined) {
        let splittedDate;
        if (this.check_List[i].fieldType == 'date') {
          let date = this.checklistFormList.value[fieldKey];
          let year = new Date(date).getFullYear();
          let month = new Date(date).getMonth() + 1;
          let day = new Date(date).getDate();
          splittedDate = day + '-' + month + '-' + year;
          this.check_List[i].value = splittedDate;
        }
        else if (this.check_List[i].fieldType == 'checkbox') {
          let temp = (this.checklistFormList.value[fieldKey] == true || this.checklistFormList.value[fieldKey] == '1' || this.checklistFormList.value[fieldKey] == true) ? true : false;
          this.check_List[i].value = temp;
        }
        else if (this.check_List[i].fieldType === 'select') {

          let temp = this.checklistFormList.value[fieldKey];
          this.check_List[i].value = temp;
          // let tempp=this.check_List[i]['multi-select']?temp:[temp]
          //  let kl:any=[]
          // this.check_List[i].options.forEach((v:any,l:any)=>{
          //   tempp.forEach((key:any)=>{
          //     if(v.id === key){
          //       kl.push(v)
          //     }
          //     else{
          //     }
          //   })
          //  })
          //  option[i]={
          //   options:kl
          //  }
        }
        else if (this.check_List[i].fieldType === 'text' && this.check_List[i].allowedValues && this.check_List[i].allowedValues.length > 0) {

          if (this.check_List[i].allowedValues) {
            checkingTextfield = true
            let temp = this.checklistFormList.value[fieldKey];
            checkfield = this.check_List[i].allowedValues.filter((v: any) => v === temp)
            this.check_List[i].value = temp;
          }
        }
        else {
          this.check_List[i].value = this.checklistFormList.value[fieldKey]
        }
      }
      let activeorder = JSON.parse(localStorage.getItem("active_order") || '{}');
      if (this.checklistFormList.value.details) {
        // this.checklistFormList.value.details.orderID = this.secondOrderId != '' ? this.DashboardComponent.secondOrderId : activeorder.orderID != '' ? activeorder.orderID : this.checklistFormList.value.details.orderID;
      }
    }
    if (checkingTextfield) {
      if (checkfield.length > 0) {

        let item = this.checklistFormList.value.details;
        let approverPayload = null;
        if(this.approverInfo){
          approverPayload = this.approverInfo;
          approverPayload.value = this.selectedUserControl.value;
        }
        let payload = {
          ...item,
          ...(approverPayload ? {"approver": approverPayload} : {}) ,
          "values": this.check_List,
          ...(autosaved ? {"autosave": true} : (autosaved === false ? {"autosave": false} : {}))
        };
        this.checklistFormList.reset({});
        if(close) {
          this.closeModal();
          // this.modalService.dismissAll();
        }
        this.apiservice.createCheckList(payload).subscribe(
          (res: createResponse) => {
            if (res.askForConfirmation === true) {
              this.confirmationMessage = res.confirmationContent;
              this.formattedConfirmationMessage = this.confirmationMessage.replace(/- /g, '<br>');
              payload.confirmation = true;
              this.payloadForConfirmation = payload;

              this.modalRef = this.modalService.open(this.confirmation, { size: "md", backdrop: 'static', keyboard: false })
            }
            if (res.response === 'validationFailed') {
              this.toastrService.error(res.errorMessage, 'Error!');
            }
            submitButton.disabled = false
            this.DashboardComponent.modaldismiss = true;
            this.orderIDD = item.orderID
            if (this.DashboardComponent.formgroupss.length > 1) {
              this.DashboardComponent.openCloseInstructionModal('2', '', '', '', this.pdfFlag, false, false);
            }
            setTimeout(() => {
              this.postPrintDetails('1', false);
            }, 200);
          },
          (error: any) => {
            console.log(error)
          }
        );
      }
      else {

        let currentlang = JSON.parse(localStorage.getItem('cuurenLanguage') || '{}');
        (Object.keys(currentlang).length) ? this.currentlang = currentlang.name : this.currentlang = 'English'
        let errormsg;
        this.errorMsg = true;
        submitButton.disabled = false;
        if (this.currentlang === 'Dutch') {
          errormsg = 'Opgegeven waarde niet toegestaan'
        }

        else if (this.currentlang === 'English') {
          errormsg = 'Value provided is not allowed'
        }
        else {
        }
        this.toastrService.error(errormsg, 'Error!');
      }
    } else {


      let item = this.checklistFormList.value.details;
      let approverPayload = null;
      if(this.approverInfo){
        approverPayload = this.approverInfo;
        approverPayload.value = this.selectedUserControl.value;
      }
      let payload = {
        ...item,
        ...(approverPayload ? {"approver": approverPayload} : {}) ,
        "values": this.check_List,
          ...(autosaved ? {"autosave": true} : (autosaved === false ? {"autosave": false} : {}))
      };
      // this.checklistFormList.reset({});
      if (pitem == 'small') {
        if(close) {
          // this.modalService.dismissAll();
          this.closeModal();
        }
      }
      this.apiservice.createCheckList(payload).subscribe(
        (res: createResponse) => {
          if (res.askForConfirmation === true) {
            this.confirmationMessage = res.confirmationContent;
            this.formattedConfirmationMessage = this.confirmationMessage.replace(/- /g, '<br>');
            payload.confirmation = true;
            this.payloadForConfirmation = payload;
            this.modalRef = this.modalService.open(this.confirmation, { size: "md" })
          }
          if (res.response === 'validationFailed') {
            this.toastrService.error(res.errorMessage, 'Error!');
          }
          submitButton.disabled = false
          this.DashboardComponent.modaldismiss = true;
          this.orderIDD = item.orderID
          if (this.DashboardComponent.formgroupss.length > 1) {
            this.DashboardComponent.openCloseInstructionModal('2', '', '', '', this.pdfFlag, false, false);
          } setTimeout(() => {
            this.postPrintDetails('1', false);
          }, 200);

        },
        (error: any) => {
          console.log(error)
        }
      );

    }
  }

setOption(
  flag: string,
  data: any,
  fetchinstructions: boolean = false
): void {
  this.selectedOption = flag;

  const activeOrder = JSON.parse(
    localStorage.getItem('active_order') || '{}'
  );

  const mappingField = activeOrder?.mapping_field || '';

  if (flag === 'instructions' ||
      (fetchinstructions && !this.instructionsItems)) {
    this.apiservice.getInstructions(
      this.orderID,
      mappingField
    ).subscribe({
      next: (res: any) => {
        if (res?.response === 'success') {
          this.instructionsItems = res.fields || '';
          this.layoutValues = res.layout;
          this.instructionsSidebar = true;
          this.cd.detectChanges();

          if (
            !this.attachments?.length &&
            (!this.checkListItems?.length || !this.checkListFormGroup)
          ) {
            this.instructionsSidebar = false;
            this.cd.detectChanges();
          }
        }
      },
      error: (error: any) => console.error(error)
    });

    return;
  }

  if (flag !== 'checklist') {
    this.displayDocument(flag, data);
  }
}

setDocument(flag: string, data: any): void {
  this.selectedOption = flag;

  if (flag === 'instructions') {
    const activeOrder = JSON.parse(
      localStorage.getItem('active_order') || '{}'
    );

    this.apiservice.getInstructions(
      this.orderID,
      activeOrder?.mapping_field || ''
    ).subscribe({
      next: (res: any) => {
        if (res?.response === 'success') {
          this.instructionsItems = res.fields || '';
          this.layoutValues = res.layout;
        }
      },
      error: (error: any) => console.error(error)
    });

    return;
  }

  if (flag !== 'checklist') {
    this.displayDocument(flag, data);
  }
}

private async displayDocument(flag: string, data: any): Promise<void> {
  if (!data) return;

  const selectionId = ++this.documentSelectionId;

  this.deviceInfo = this.deviceService.getDeviceInfo();
  this.selectedOption = flag;
  this.Werkbon = true;
  this.isLoading = true;

  if (data.base_64) {
    this.currentDocumentType = 'pdf';
    this.blobPdf = true;
    this.imageUrl = null;
    this.src = null;

    this.loadPdfOffline(data.base_64, data, flag);
    return;
  }

  const filename = data.filename || '';

  const fileUrl = /^https?:\/\//i.test(filename)
    ? filename
    : this.config.fileurl + filename;

  if (this.isImageSource(data, fileUrl)) {
    this.currentDocumentType = 'image';
    this.blobPdf = false;
    this.src = null;
    this.pdfViewerUrl = null;
    this.imageUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);

    this.isLoading = false;
    this.cd.detectChanges();
    return;
  }

  this.currentDocumentType = 'pdf';
  this.blobPdf = false;
  this.imageUrl = null;
  this.src = null;
  this.pdfViewerUrl = null;

  // Use the actual resolved URL, including for absolute SharePoint
  // and Amazon S3 URLs. The custom viewer handles PDF rendering.
  try {
    const cachedFileUrl = await this.getRemotePdfObjectUrl(fileUrl);
    // A slower previous request should not replace a newer tab selection.
    if (selectionId !== this.documentSelectionId) return;
    this.openPdfViewer(data, cachedFileUrl, fileUrl, flag);
  } catch {
    // Preserve current behavior for servers that do not allow cross-origin fetch.
    if (selectionId !== this.documentSelectionId) return;
    this.openPdfViewer(data, fileUrl, fileUrl, flag);
  }
}

private getRemotePdfObjectUrl(fileUrl: string): Promise<string> {
  const cached = this.remotePdfUrls.get(fileUrl);
  if (cached) return cached;

  const request = fetch(fileUrl, { credentials: 'same-origin' })
    .then(response => {
      if (!response.ok) {
        throw new Error(`PDF request failed with status ${response.status}`);
      }
      return response.blob();
    })
    .then(blob => {
      const pdfBlob = blob.type === 'application/pdf'
        ? blob
        : new Blob([blob], { type: 'application/pdf' });
      const objectUrl = URL.createObjectURL(pdfBlob);
      this.pdfObjectUrls.push(objectUrl);
      return objectUrl;
    })
    .catch(error => {
      // Allow a later selection to retry if fetching failed.
      this.remotePdfUrls.delete(fileUrl);
      throw error;
    });

  this.remotePdfUrls.set(fileUrl, request);
  return request;
}

  getClass(value: any) {
    return `col-md-${value}`;
  }
  async localHosthandler(item: any) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let obj = {
          labeldata: item.labeldata,
          copies: item.quantity
        }
        this.apiservice.localhostPost(obj).toPromise();
        resolve('success');
      }, 200);
    });
  }


  async postPrintDetails(flag: string, autoprint: boolean) {
    let current_user: any = JSON.parse(localStorage.getItem('current_user') || '');
    let askQuantity;
    let autoPrint;
    let processStep;
    let printOptions = false;
    let order: any = localStorage.getItem("active_order");
    let activeorder = JSON.parse(localStorage.getItem("active_order") || '{}');
    let orderIdd: any;
    orderIdd = this.secondOrderId != '' ? this.DashboardComponent.secondOrderId : activeorder.orderID != '' ? activeorder.orderID : this.orderIDD;
    let allOrders = JSON.parse(localStorage.getItem(current_user?.userID + 'allOrders') || '[]');
    console.log('All Orders >>',allOrders)
    let orderSubject = allOrders.find((item:any)=> item.orderID == orderIdd);
    let orderkey = activeorder.mapping_field ? activeorder.mapping_field : 
    (orderSubject ? orderSubject.mapping_field : '');
    (order) ? order = JSON.parse(order) : "";
    if (this.customizing?.triggerPrint != null) {
      this.customizing?.triggerPrint?.forEach((element: any) => {
        autoPrint = element.autoprint
        if (element.processStep == 'afterChecklistComplete') {
          printOptions = true;
          processStep = element.processStep;
        }
        askQuantity = element.askQuantity;
      });

      if (flag == '1' || (flag == '0' && askQuantity != true && printOptions)) {
        if (autoPrint || autoprint) {
          let obj: any = {}
          for (let i = 0; i < this.parentResult?.length; i++) {
            let print = this.parentResult[i].id
            let formValues = this.productForm.value;
            if (print in formValues) {
              obj[print] = this.productForm.value[print]
            }
          }
          let payload = {
            ...obj,
            "orderID": orderIdd,
            "quantity": (!this.modalref) ? null : this.productForm.value?.quantity?.toString(),
            "userID": current_user?.userID,
            "orderkey": orderkey,
            "processStep": this.productForm.value?.types ? this.productForm.value.types : processStep,
          };
          (this.modalref) ? this.modalref.close() : '';
          this.apiservice.addQuantity(payload).subscribe(
            async (res: any) => {
              if (res?.response == 'success') {
                if (res?.printbody != null) {
                  for (let i in res.printbody) {
                    await this.localHosthandler(res.printbody[i]);
                  }
                }
                this.productForm.reset({});
                this.secondOrderId = '';
                this.modalref;
              }
            },
            (error: any) => {
              console.log(error)
            }
          );
        }
      } else {
        this.apiservice.aaddQuantity(orderIdd, orderkey, current_user?.userID, this.workstationid).subscribe(
          async (res: any) => {
            this.getPostValues = res;
            this.defaultValue = res.types[0]?.processStep;
            this.onChangeLabel(this.defaultValue)
            this.productForm.get('quantity').setValue(res.default_quantity)
          })

        if (askQuantity == true) {
          this.modalref = this.modalService.open(this.content, { modalDialogClass: 'orderline', backdrop: 'static', keyboard: false });
          this.modalRef?.closed.subscribe(() => {
              this.executePendingModals();
          });
          this.modalRef?.dismissed.subscribe(() => {
              this.executePendingModals();
          });
        }
      }

    }
    else {
      this.printOptinal(1)
    }
  }


  async printOptinal(flag: any) {
    let current_user: any = JSON.parse(localStorage.getItem('current_user') || '');
    let askQuantity;
    let autoPrint;
    let processStep;
    let printOptions = false;
    let order: any = localStorage.getItem("active_order");
    let activeorder = JSON.parse(localStorage.getItem("active_order") || '{}');
    let orderIdd: any;
    orderIdd = this.secondOrderId != '' ? this.DashboardComponent.secondOrderId : activeorder.orderID != '' ? activeorder.orderID : this.orderIDD;
    if (flag == '1') {
      let payload = {
        "orderID": orderIdd,
        "quantity": (!this.modalref) ? null : this.productForm.value?.quantity?.toString(),
        "userID": current_user?.userID,
        "orderkey": activeorder.mapping_field ? activeorder.mapping_field : '',
        "processStep": this.productForm.value?.types ? this.productForm.value.types : processStep,
      };
      (this.modalref) ? this.modalref.close() : '';
      this.apiservice.addQuantity(payload).subscribe(
        async (res: any) => {
          if (res?.response == 'success') {
            if (res?.printbody != null) {
              for (let i in res.printbody) {
                await this.localHosthandler(res.printbody[i]);
              }
            }
            this.productForm.reset({});
            this.secondOrderId = '';
            this.modalref;
          }
        },
        (error: any) => {
          console.log(error)
        }
      );

    } else {
      let orderkey = activeorder.mapping_field ? activeorder.mapping_field : '';
      this.apiservice.aaddQuantity(orderIdd, orderkey, current_user?.userID, this.workstationid).subscribe(
        async (res: any) => {
          this.getPostValues = res;
          this.defaultValue = res.types[0].processStep;
          this.productForm.get('quantity').setValue(res.default_quantity);
          for (let list of this.getPostValues?.types) {
            this.productForm.addControl(list.description, new FormControl(''));
          }
        })

      this.modalref = this.modalService.open(this.content, { modalDialogClass: 'orderline', backdrop: 'static', keyboard: false });
      this.modalRef?.closed.subscribe(() => {
          this.executePendingModals();
      });
      this.modalRef?.dismissed.subscribe(() => {
          this.executePendingModals();
      });
    }
  }

  public onChangeLabel(event: any): void {
    const selectedStep = event;
    const parentResult = this.getPostValues?.types?.flatMap((v: any) =>
      v?.inputfields?.map((k: any) => ({
        ...k,
        parent: v.processStep
      }))
    ) || [];
    this.parentResult = parentResult.filter((v: any) => v.parent === selectedStep);
    this.parentResult.forEach((field: any) => {
      const controlName = field.id;
      const defaultValue = field.default ?? '';

      if (this.productForm.contains(controlName)) {
        this.productForm.patchValue({ [controlName]: defaultValue });
      } else {
        this.productForm.addControl(controlName, new FormControl(defaultValue));
      }
    });
  }

  openExtraInputModal(modal: any) {
    this.modalService.open(modal, { size: 'md', backdrop: 'static', keyboard: false });
  }

  activities() {
    this.apiservice.getgreenactivities().subscribe(
      (res: customizing) => {
        if (res.response) {
          this.customizing = res.response;
        } else {
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  private focusFotoTabIfNeeded(attachmentFiles?: any): boolean {
    if (this.workstationid != '57') {
      return false;
    }
    const files = attachmentFiles?.length ? attachmentFiles : (this.attachments?.length ? this.attachments : []);
    const fotoAttachment = files?.find?.((item: any) => item?.document_type == 'Foto');
    if (!fotoAttachment) {
      return false;
    }
    if (this.selectedOption === 'Foto' && this.isD === false) {
      return true;
    }
    // this.setOption(fotoAttachment.document_type, fotoAttachment);
    this.setDocument(fotoAttachment.document_type, fotoAttachment);
    this.isD = false;
    this.isShoww = false;
    this.isShow = false;
    this.instructionsSidebar = true;
    this.Werkbon = true;
    this.cd.detectChanges();
    return true;
  }

  private resetDocumentState(): void {
    this.Werkbon = false;
    this.isD = true;
    this.imageUrl = null;
    this.currentDocumentType = null;
    this.src = null;
    this.pdfViewerUrl = null;
    this.blobPdf = false;
  }

  openInstructionList(instructions: any, payload: any, checklistFlag: any, stepFlag: string, attachmentFiles: any, dialogType: string, secondOrderId: any, pdfFlag: boolean, instructionanddoc: boolean) {
    
    if (attachmentFiles?.length > 0) {
      this.attachments = attachmentFiles;
    }
    
    // Ensure orderID is set from payload or localStorage
    if (!this.orderID) {
      if (payload?.orderID) {
        this.orderID = payload.orderID;
      } else {
        const activeOrder = JSON.parse(localStorage.getItem("active_order") || '{}');
        this.orderID = activeOrder.orderID;
      }
    }
    
    this.customizing = JSON.parse(localStorage.getItem('customizing') || '{}')
    // Reset document state because this component can be reused for another order.
    if (attachmentFiles) {
      this.attachments = attachmentFiles;
    }
    this.resetDocumentState();
    this.selectedOption = '';
    this.pdfFlag = pdfFlag;
    this.secondOrderId = secondOrderId
    this.isShow = true;
    this.index = 1;
    this.maxIndex = 0;
    this.stepFlag = stepFlag;
    this.showChecklist = false;
    this.showInstructions = false;
    if (instructionanddoc || this.instructionsDocumentValue || instructions === this.suncircle) {
      this.instructionsSidebar = true;
      this.cd.detectChanges();
    }

    if (payload && payload?.processStep != '') {
      if (checklistFlag == true) {
        if(this.customerID != 6 || (this.checkListItems?.length > 0 && this.checkListFormGroup)) {
          console.log('Checklist flag is true and conditions are met');
          this.showChecklist = checklistFlag;
          this.selectedOption = 'checklist';
          this.customerID == '6' ? this.setOption('checklist', '',  true): '';
        }else{
          this.selectedOption = '';
          this.setOption('instructions', '');
        }
      } else if (this.customizing?.showInstructions == stepFlag) {
        if( this.customerID == '6'){

          this.selectedOption = '';
          this.setOption('instructions', '');
        }else{
          this.showInstructions = true;
          this.setOption('instructions', '');
        }
      } else {
        this.showChecklist = true;
        this.selectedOption = 'checklist';
        this.setOption('checklist', '');
        if (instructionanddoc) {
          setTimeout(() => {
            if (!this.focusFotoTabIfNeeded(attachmentFiles)) {
              this.setOption('instructions', '');
            }
          }, 500)
        }


      }
    } else {
      if (this.customizing.showInstructions != null) {
        this.showInstructions = true;
        this.setOption('instructions', '');
      }
      else if (instructionanddoc) {
        this.showInstructions = true;
        this.setOption('instructions', '');
      }
      else {
        if (attachmentFiles?.length > 0) {
          this.setOption(attachmentFiles[0]?.document_type, attachmentFiles[0]);
        } 
        // else {
        //   this.showChecklist = true;
        //   this.setOption('checklist', '');
        // }
      }
    }
    this.focusFotoTabIfNeeded(attachmentFiles);
    if(this.instructionsSidebar){
      // check if there is any attachments or checklist 
      if (
        !attachmentFiles?.length &&
        (!this.checkListItems?.length || !this.checkListFormGroup)
      ) {
        this.instructionsSidebar = false;
        this.cd.detectChanges();
      }
    }
    if (dialogType === 'small') {
      let closeResult
      this.checklistModalRef = this.modalService.open(this.extrainputpopup, { size: 'md', backdrop: 'static', keyboard: false });
      this.checklistModalRef.closed.subscribe(() => {
        console.log('Modal closed, executing pending modals');
        this.executePendingModals();
      });
      this.checklistModalRef.dismissed.subscribe(() => {
        console.log('Modal dismissed, executing pending modals');
        this.executePendingModals();
      });
      this.checklistModalRef.result.then((result) => {
        closeResult = `Closed with: ${result}`;
        this.errorMsg = false
      }, (reason) => {
        this.errorMsg = false;
        closeResult = `Dismissed ${this.getDismissReason(reason)
        }`;
        this.clearSubscriptions();
      });;
      setTimeout(() => {
        let item;
        (this.checkListItems?.length > 0) ? item = this.checkListItems[0] : item = '';
        const projectInput: any = document.querySelector(`input[name='${item.fieldID ?? item.fieldName}'` + ']');
        projectInput?.focus();
      }, 500);
    } else {
      // let checklistFlagg = checklistFlag = true ? 'checklist' : 'instructor'
      let closeResult;
      this.checklistModalRef = this.modalService.open(instructions, { modalDialogClass: `instructions ${checklistFlag} `, backdrop: 'static', keyboard: false });
      this.checklistModalRef.closed.subscribe(() => {
        console.log('Modal closed, executing pending modals');
        this.executePendingModals();
      });
      this.checklistModalRef.dismissed.subscribe(() => {
        console.log('Modal dismissed, executing pending modals');
        this.executePendingModals();
      });
      this.checklistModalRef.result.then((result) => {
        closeResult = `Closed with: ${result}`;
        this.errorMsg = false
      }, (reason) => {
        this.errorMsg = false;
        this.DashboardComponent.hideInstructionpopup = false;
        closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.showInput = false;
        this.inputText = ''
        this.diactivatedFlag = false;
        this.diactivatedFlagfromdash = false;
        if (closeResult !== 'Dismissed with: Cross clicked') {
          if (this.DashboardComponent.triggerChecklist?.length <= 1) {
            // this.DashboardComponent.checkListItems = [];
            // this.DashboardComponent.checkListFormGroup?.reset({});
            // this.DashboardComponent.checkListFormGroup1?.reset({});
            // this.DashboardComponent.checkListItems1 = [];
          }
        }
        this.clearSubscriptions();
        console.log('CLosing with execution');
        // this.executePendingModals(); // Remove from here since we have subscriptions
      });;;
      const modal: any = document.querySelector("ngb-modal-window");
      modal.style.overflow = "hidden";
      // const modal1: any = document.querySelector("false");
      // modal1.style.visibility = 'hidden !important'
      // modal.style['z-index'] = '0 !important';
    }
    this.previewData();
    let filter = this.checkListItems.filter((v: any) => v.options && v.page == 1)
    console.log(filter, 'f')
    let id = filter[0]?.value ? 'yes' : 'no'
    this.onChangeRadio('', id, filter[0])
  }

  previewData() {
    this.nextPage = [...this.checkListItems];
    this.checkListItems.forEach((item:any)=>{
      const withBreaks = item?.fieldName?.replace(/\n/g, '<br />');
      item.safeFieldLabel = this.sanitizer.bypassSecurityTrustHtml(withBreaks);
    })
    this.checklistItemss = [...this.checkListItems];
    if(this.checklistItemss.some((item:any)=> item.page)){
      this.nextPage.filter((v: any) => this.maxIndex < v.page ? this.maxIndex = v.page : 0)
      this.checklistItemss = this.nextPage.filter((v: any) => v.page == 1)
    }else{
      this.maxIndex = 0;
    }
  }
  async nextData() {
    let isInvalid : boolean[] = [];
    this.checklistItemss.forEach((item: any) => {
      this.validateInput(item);
      isInvalid.push(this.hasAnyError(item));
    })

    let canProceed = true;
    if(this.autosave == 1) {
      canProceed = await this.addChecklist('', null, false, false);
    }
    
    this.nextPage = [...this.checkListItems];
    if (this.index < this.maxIndex && !isInvalid.some((v:boolean)=> v) && canProceed) {
      this.index = this.index + 1;
      this.saveCurrentPageData()
      this.isshowDependingOn = false;
      this.checklistItemss = this.nextPage.filter((v: any) => v.page === this.index);
      // If the content is long, scroll the modal body to the top so user sees the new page header
      this.scrollToTopIfLong();
    }
  }
  prevData() {
    this.isshowDependingOn = true;
    this.nextPage = [...this.checkListItems];
    if (this.index > 1) {
      this.index = this.index - 1;
      this.saveCurrentPageData()
      this.isshowDependingOn = false;
      this.checklistItemss = this.nextPage.filter((v: any) => v.page == this.index)
      // Scroll up when navigating to previous page
      this.scrollToTopIfLong();
    }
  }

  private scrollToTopIfLong(): void {
    // Use a single short setTimeout to allow DOM update, then scroll immediately for snappier UX.
    setTimeout(() => {
      try {
        const selectors = [
          'ngb-modal-window .modal-body',
          '.modalcontenoverflow',
          '.instructions-content',
          '.projectbody',
          '.modal-body'
        ];
        for (const sel of selectors) {
          const el = document.querySelector(sel) as HTMLElement | null;
          if (el && el.scrollHeight > el.clientHeight) {
            try {
              el.scrollTo({ top: 0, behavior: 'smooth' });
            } catch (e) {
              el.scrollTop = 0;
            }
            return;
          }
        }
        // Fallback: scroll window
        try {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (e) {
          window.scrollTo(0, 0);
        }
      } catch (err) {
        // don't let scrolling errors break the modal flow
      }
    }, 10);
  }
  saveCurrentPageData() {
    this.checkListItems.forEach((item: any) => {
      const idx = this.nextPage.findIndex((i: any) => i.id === item.id);
      console.log(idx)
    });
    console.log(this.nextPage)
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public openLocatie(modal: any): void {
    this.locatieForm.reset()
    if (this.instructionsItems?.canModify) {
      for (let i = 0; i < this.instructionsItems.canModify.length; i++) {
        let key = this.instructionsItems.canModify[i]['name'];
        this.locatieForm.addControl(key, new FormControl(''));
      }
    }
    this.modalref = this.modalService.open(modal, { modalDialogClass: 'locatie-wrapper-dailog', backdrop: 'static', keyboard: false });
  }

  forceVirtualKeyboard() {
    if (!this.forceVirtualKeyboardEnabled) return;
    const input = document.createElement('input');
    input.style.position = 'absolute';
    input.style.opacity = '0';
    input.style.height = '0';
    input.style.width = '0';
    input.style.zIndex = '-1';
    document.body.appendChild(input);
    input.focus();
    setTimeout(() => {
      input.blur();
      document.body.removeChild(input);
    }, 100);
  }
  public locatieSubmit(): void {
    let p: any = this.locatieForm.value
    let obj = Object.keys(p).map(k => ({
      name: k,
      value: p[k]
    }))
    let activeorder = JSON.parse(localStorage.getItem("active_order") || '{}');
    let payload = {
      orderID: activeorder.orderID,
      orderkey: activeorder.mapping_field ? activeorder.mapping_field : '',
      field: obj
    }
    this.apiservice.postInstructions(payload).subscribe(res => {
      this.modalref.close()
    })
  }

  onChangeRadio(value: any, id: any, pr: any) {
    this.checkListItems.forEach((v: any, index: any) => {
      const propField = pr?.fieldID ?? pr?.fieldName;
      const dependantField = v?.showDependingOn?.fieldID ?? v?.showDependingOn?.fieldName;
      if (
        propField === dependantField &&
        v?.showDependingOn?.value === id
      ) {
        v['isVisible'] = true;
      } else {
        v['isVisible'] = false;
      }


    })
  }

  public proceed(): void {


    const payload = { ...this.payloadForConfirmation };
    this.speedSaveDisabled = true;
    this.apiservice.createCheckList(payload).subscribe(
      (res: createResponse) => {
        //  if (res.askForConfirmation === true) {
        //     this.confirmationMessage = res.confirmationContent;
        //     payload.confirmation = true;
        //     this.payloadForConfirmation = payload;
        //     this.modalRef = this.modalService.open(this.confirmation, { size: "md" })
        //   }
        if (res.response == "success") {
          // this.modalService.dismissAll();
          this.closeModal(null, true);
        }
        this.speedSaveDisabled = false;
      }, 
      (error)=>{
        this.speedSaveDisabled = false;
      })
    //  if (this.modalRef) {
    //       this.modalRef.close(); // or dismiss()
    //       this.modalRef = null;

    //     }
  }
  public close() {
    this.closeModal(this.modalRef, true);
    // if (this.modalRef) {
    //   this.modalRef.close();
    // }
    // this.modalService.dismissAll();
  }

  async getAvailableCameras() {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      this.availableCameras = devices.filter(device => device.kind === 'videoinput');
      if (this.availableCameras.length === 0) {
        this.errorMessage = 'No cameras found on this device';
      }
    } catch (err) {
      console.error('Error enumerating devices:', err);
      this.errorMessage = 'Unable to access device cameras';
    }
  }

  openCamera(propField: string) {
    if (this.availableCameras.length > 0) {

      const modalRef = this.modalService.open(CameraCaptureComponent, {size: 'lg', scrollable: true, windowClass:'camera-modal', backdrop: 'static', keyboard: false});
      modalRef.result.then((imageUrl) => {
        this.onImageCaptured(imageUrl, propField);
      });
    }
  }

  onImageCaptured(imageUrl: any, propField: string) {
    if (imageUrl) {
      if(!Array.isArray(this.getListField(propField).value)) this.getListField(propField).value = []; 
      this.getListField(propField)?.value.push(imageUrl);
      this.triggerChecklistChange();
      this.validateInput(this.getListField(propField));
    }
  }

  removePhoto(index: number, propField: string) {
    this.getListField(propField)?.value.splice(index, 1);
    this.triggerChecklistChange();
    this.validateInput(this.getListField(propField));
  }

  onFileSelected(event: any, fieldName: string){
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      const reader = new FileReader();

      reader.onload = () => {
        const base64Image = reader.result as string;
        this.getListField(fieldName)?.value.push(base64Image);
        this.triggerChecklistChange();
      };
      
      reader.onerror = (err) => {
        console.error('FileReader error:', err);
      };
      
      reader.readAsDataURL(file); // 🔄 Converts to base64 string
      // const selectedField = this.checkListItems.find((item: checklistItem) => item.fieldName === fieldName);
      // selectedField.value = this.takenPhotos; 
    }
  }

  openFilePicker(fieldId: string): void {
    const fileInput = document.getElementById(fieldId) as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  getUserList(){
    this.apiservice.getAvailableUsersList('', this.workstationid).subscribe(res => {
      this.usersList = Array.isArray(res.res) ? res.res : (res.res ? [res.res] : []);
    });
  }

  getListField(prop: any) {
    if(prop.fieldID)
      return this.checkListItems.find((item: checklistItem) => item.fieldID === prop.fieldID);
    else 
      return this.checkListItems.find((item: checklistItem) => item.fieldName === prop.fieldName);
  }

fieldVisibility(prop: any){
  if(prop.showDependingOn){
    const fieldKey = prop?.showDependingOn?.fieldID ?? prop?.showDependingOn?.fieldName;
    // const dependantField = this.checkListItems.find((item:any)=> item.fieldName === fieldKey);
    const dependantFieldValue = this.checkListFormGroup.value[fieldKey];
    if(dependantFieldValue === prop.showDependingOn.value) return true;
    else return false
  }else{
    return true;
  }
}

  private showSaveMessage(success: boolean) { 
    this.saveMessage = success;
    setTimeout(()=>{
      this.saveMessage = null;
    }, 3000)
  }

checkConcurrentWarningVisibility(event: any){
  if(event.userID === this.currentuser?.userID && event.workStationID === +this.workstationid){
    if(event.eventType === 'removeChecklistWarning') this.displayConcurrencyMessage = false;
    if(event.eventType === 'addChecklistWarning') this.displayConcurrencyMessage = true;
  }
}

validateInput(fieldData: any){
  let field = this.getListField(fieldData);
  if(!this.fieldVisibility(fieldData)) {
    field.errors = {};
    return;
  };
  // let formField = this.checkListFormGroup.get(fieldData.fieldName);
  let formField = this.checkListFormGroup.controls[fieldData.fieldID ?? fieldData.fieldName];
  const value = this.checkListFormGroup.value[fieldData.fieldID ?? fieldData.fieldName];
  const validationConstraints = Object.keys(fieldData).map((key=> ['minLength', 'maxLength', 'minValue', 'maxValue'].includes(key)? key : null)).filter(item => item !== null);
  if(validationConstraints.length > 0) {
    // Apply validation rules
    validationConstraints.forEach((constraint) => {
      switch (constraint) {
        case 'minLength':
          // Apply minLength validation
          if(field && field.minLength){
            if (field.fieldType !== 'photo' && field.fieldType !== 'boolean' && (!value || String(value).length < field.minLength)) {
              field.errors = { ...field.errors, minLength: true };
            }
            else if(field.fieldType == 'photo' && formField.value && Array.isArray(formField.value) && formField.value.length < field.minLength){
              field.errors = { ...field.errors, minLength: true };
            }
            else if(field.fieldType == 'boolean' && field.minLength == 1 && !formField.value){
              field.errors = { ...field.errors, minLength: true };
            }
            else{
              field.errors = { ...field.errors, minLength: false };
            }
          }
          break;
          case 'maxLength':
            // Apply maxLength validation
            if(field && field.maxLength){
              if (field.fieldType !== 'photo' && field.fieldType !== 'boolean' && (!value || String(value).length > field.maxLength)) {
                field.errors = { ...field.errors, maxLength: true };
              }
              else if(field.fieldType == 'photo' && formField.value && Array.isArray(formField.value) && formField.value.length > field.maxLength){
                field.errors = { ...field.errors, maxLength: true };
              }
              else{
                field.errors = { ...field.errors, maxLength: false };
              }
          }
          break;
        case 'minValue':
          // Apply minValue validation
          if (field && field.fieldType == 'float' && field.minValue && Number(value) < field.minValue) {
            field.errors = { ...field.errors, minValue: true };
          }else{
            field.errors = { ...field.errors, minValue: false };
          }
          break;
        case 'maxValue':
          // Apply maxValue validation
          if (field && field.fieldType == 'float' && field.maxValue && Number(value) > field.maxValue) {
            field.errors = { ...field.errors, maxValue: true };
          }else{
            field.errors = { ...field.errors, maxValue: false };
          }
          break;
      }
    });
  }
}

hasAnyError(prop:any): boolean {
  if(!prop.errors) return false;
  return Object.values(prop.errors).some(val => val === true);
}

getFormField(name: any){
  return (this.checkListFormGroup as FormGroup).controls[name]
}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.currentuser = null;
    this.pdfObjectUrls.forEach(url => URL.revokeObjectURL(url));
    this.pdfObjectUrls = [];
    this.remotePdfUrls.clear();
  }

  clearSubscriptions(){
    if (this.autosaveTimeout) {
      clearTimeout(this.autosaveTimeout);
    }
    this.Werkbon = false;
    this.src = null;
    this.imageUrl = null;
    this.currentDocumentType = null;
    this.pdfViewerUrl = null;
    this.blobPdf = false;
    if(this.formChangeSubscription){
      this.formChangeSubscription.unsubscribe();
      this.formChangeSubscription.closed = true;
      this.formChangeSubscription = null;
    }
    this.isDebouncing = false;
    this.alreadySaved = false;
    if(this.autosave == 1){
      this.isSaveButtonDisabled = true;
    }
    this.selectedUserControl.reset();
    this.selectedUserControl.updateValueAndValidity();
    this.nfcStatus = 'idle';
    this.nfcBuffer = '';
    this.pdfViewerStates = {};
    console.log('selected user control reset in clearSubscriptions');
  }
  
  closeModal(modal?: any, force?: boolean){
    this.clearSubscriptions();
    if(modal){
      modal.close();
    }
    else if(this.checklistModalRef){
      this.checklistModalRef.close();
    } 
    else{
      this.modalService.dismissAll();
    } 
    if(force){
      this.modalService.dismissAll();
    }
    // Do not execute pending modals here: modal close/dismiss events already handle it.
  }
  
  async executePendingModals(){
    if(this.DashboardComponent.pendingModals.length === 0){
      return;
    }
    const nextModal = this.DashboardComponent.pendingModals.shift();
    try {
      await nextModal?.();
    } catch (error) {
      console.error('Error executing pending modal', error);
    }
  }

  onInputClick(condition : boolean,event: Event) {
    if (condition) {
      this.diactivatedFlag = true;
      event.stopPropagation();
      this.hideForUrl();
    }
  }

  formatAndSanitizeHtml(text: any) {
    if (!text) return '';
    // replace newlines with <br>
    const withBreaks = text.replace(/\n/g, '<br />');
    return this.sanitizer.bypassSecurityTrustHtml(withBreaks);
  }

private getAttachmentIndex(data: any): number {
  const attachments = Array.isArray(this.attachments)
    ? this.attachments
    : [];

  const index = attachments.indexOf(data);

  if (index >= 0) return index;

  const matchingIndex = attachments.findIndex((attachment: any) =>
    attachment?.filename === data?.filename &&
    attachment?.document_type === data?.document_type
  );

  return matchingIndex >= 0 ? matchingIndex : 0;
}

private openPdfViewer(
  data: any,
  fileUrl: string,
  sourceKey: string,
  documentType: string
): void {
  const attachmentIndex = this.getAttachmentIndex(data);

  let viewer = this.pdfViewers.find(
    item => item.attachmentIndex === attachmentIndex
  );

  if (!viewer || viewer.sourceKey !== sourceKey) {
    const viewerUrl = new URL(
      'assets/pdfjs/custom-viewer.html',
      document.baseURI
    );

    viewerUrl.searchParams.set('file', fileUrl);
    viewerUrl.searchParams.set(
      'attachmentIndex',
      String(attachmentIndex)
    );

    viewer = {
      attachmentIndex,
      documentType,
      fileUrl,
      sourceKey,
      viewerUrl: this.sanitizer
        .bypassSecurityTrustResourceUrl(viewerUrl.toString())
    };

    const existingIndex = this.pdfViewers.findIndex(
      item => item.attachmentIndex === attachmentIndex
    );

    if (existingIndex >= 0) {
      this.pdfViewers[existingIndex] = viewer;
    } else {
      this.pdfViewers.push(viewer);
    }

    delete this.pdfViewerStates[attachmentIndex];
  } else {
    // Reuse the existing viewer; do not reset its scroll position.
    viewer.documentType = documentType;
    this.isLoading = false;
  }

  this.activePdfAttachmentIndex = attachmentIndex;
  this.cd.detectChanges();
}

loadPdfOffline(
  base64: string,
  data: any,
  documentType: string
): void {
  const attachmentIndex = this.getAttachmentIndex(data);
  const sourceKey = base64;

  const existingViewer = this.pdfViewers.find(
    item =>
      item.attachmentIndex === attachmentIndex &&
      item.sourceKey === sourceKey
  );

  if (existingViewer) {
    existingViewer.documentType = documentType;
    this.activePdfAttachmentIndex = attachmentIndex;
    this.isLoading = false;
    this.cd.detectChanges();
    return;
  }

  const bytes = this.base64ToUint8Array(base64);
  const blob = new Blob([bytes], { type: 'application/pdf' });
  const fileUrl = URL.createObjectURL(blob);

  this.pdfObjectUrls.push(fileUrl);

  this.openPdfViewer(data, fileUrl, sourceKey, documentType);
}

base64ToUint8Array(base64: string): Uint8Array {
  const cleaned = base64.replace(
    /^data:application\/pdf;base64,/,
    ''
  );

  const binary = atob(cleaned);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return bytes;
}


private spinInterval: any = null;
private spinTimeout: any = null;

stepValue(prop: any, delta: number, isInt: boolean): void {
  const control = this.checkListFormGroup.controls[prop.fieldID ?? prop.fieldName];
  let field = this.getListField(prop);
  console.log(control, 'control')
  console.log(prop, 'prop')
  if (!control) return;
  if(control.disabled) return;

  const current = parseFloat(control.value) || 0;
  let next = current + delta;

  if (isInt) {
    next = Math.round(next);
  } else {
    next = parseFloat(next.toFixed(10));
  }

  if (prop.min !== undefined && next < prop.min) next = prop.min;
  if (prop.max !== undefined && next > prop.max) next = prop.max;

  control.setValue(next);
  prop.value = next;
}

// Hold-to-spin: delay then repeat
startSpin(prop: any, delta: number, isInt: boolean): void {
  this.spinTimeout = setTimeout(() => {
    this.spinInterval = setInterval(() => {
      this.stepValue(prop, delta, isInt);
    }, 80); // repeat speed in ms
  }, 400); // delay before repeat starts
}

stopSpin(): void {
  clearTimeout(this.spinTimeout);
  clearInterval(this.spinInterval);
  this.spinTimeout = null;
  this.spinInterval = null;
}

isFormDisabled(controlName: string): boolean {
  const control = this.checkListFormGroup.controls[controlName];
  return control ? control.disabled : false;
}

onNfcButtonClick(): void {
  // Reset previous state
  this.cleanupNfcListener();

  this.nfcBuffer = '';
  this.selectedUserControl.reset();
  this.selectedUserControl.updateValueAndValidity();
  this.nfcStatus = 'listening';
  this.cd.markForCheck();
  this.cd.detectChanges();

  // Start 10 second timeout
  this.nfcTimeout = setTimeout(() => {
    this.ngZone.run(() => {
      this.nfcStatus = 'timeout';
      this.cleanupNfcListener();
      this.cd.markForCheck();
      this.cd.detectChanges();
    });
  }, 10000);

  // Start listening to keyboard input
  this.keyboardListener = (event: KeyboardEvent) => {
    console.log('Key pressed:', event.key);
    // Ignore modifier keys
    if (
      event.key === 'Shift' ||
      event.key === 'Control' ||
      event.key === 'Alt' ||
      event.key === 'Meta'
    ) {
      return;
    }

    // Scanner usually sends Enter after scan completes
    if (event.key === 'Enter') {
      event.preventDefault();
      const scannedValue = this.nfcBuffer.trim();

      this.ngZone.run(() => {
        if (scannedValue) {
          this.selectedUserControl.setValue(scannedValue);
          this.selectedUserControl.updateValueAndValidity();

          this.nfcStatus = 'success';
          this.cd.markForCheck();
          this.cd.detectChanges();

          console.log('NFC Scan Success:', scannedValue, this.nfcStatus);
        } else {
          this.nfcStatus = 'timeout';
          this.cd.markForCheck();
          this.cd.detectChanges();
        }

        this.cleanupNfcListener();
      });

      return;
    }

    // Append scanned characters
    this.nfcBuffer += event.key;
  };

  window.addEventListener('keydown', this.keyboardListener);
}

private cleanupNfcListener(): void {
  clearTimeout(this.nfcTimeout);

  if (this.keyboardListener) {
    window.removeEventListener('keydown', this.keyboardListener);
  }
}

private resolveDocumentUrl(data: any): string {
  const filename = data?.filename ?? '';

  if (
    filename.startsWith('http://') ||
    filename.startsWith('https://')
  ) {
    return filename;
  }

  return `${this.config.fileurl}${filename}`;
}
}
